import { render, staticRenderFns } from "./StoreDecorate.vue?vue&type=template&id=cc858410&scoped=true"
import script from "./StoreDecorate.vue?vue&type=script&lang=js"
export * from "./StoreDecorate.vue?vue&type=script&lang=js"
import style0 from "./StoreDecorate.vue?vue&type=style&index=0&id=cc858410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc858410",
  null
  
)

export default component.exports